module.exports = __webpack_public_path__ + "706aadefd947c8356333efdd89b601ec.svg";